// This generated JSON contains only names. Keep CDK's configuration and runtime
// imports out of the browser dependency graph, including its source maps.
import productionClientTenantSlugs from 'aws-cdk-core/build/browser/productionClientTenantSlugs.json';

const productionHostnames = new Set([
  'getcartwheel.com',
  'www.getcartwheel.com',
  'studio.getcartwheel.com',
  'www.studio.getcartwheel.com',
  'app.getcartwheel.com',
  'www.app.getcartwheel.com',
  'docs.getcartwheel.com',
  'www.docs.getcartwheel.com',
  ...productionClientTenantSlugs.map((slug) => `${slug}.getcartwheel.com`),
]);

export function usesLiveServiceCredentials(): boolean {
  // Match API routing, without the feature flag's localStorage envOverride.
  const disambiguator = import.meta.env.VITE_API_DISAMBIGUATOR ?? '';
  if (disambiguator !== '') return false;

  // Prerendering has no hostname; use the build's API environment.
  if (typeof window === 'undefined') return true;

  return productionHostnames.has(window.location.hostname.toLowerCase());
}
